/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyExternalOrderShipment from './pharmacy-external-order-shipment';
import PharmacyExternalOrderShipmentDetail from './pharmacy-external-order-shipment-detail';
import PharmacyExternalOrderShipmentUpdate from './pharmacy-external-order-shipment-update';
import PharmacyExternalOrderShipmentDeleteDialog from './pharmacy-external-order-shipment-delete-dialog';

const PharmacyExternalOrderShipmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyExternalOrderShipment />} />
    <Route path="new" element={<PharmacyExternalOrderShipmentUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyExternalOrderShipmentDetail />} />
      <Route path="edit" element={<PharmacyExternalOrderShipmentUpdate />} />
      <Route path="delete" element={<PharmacyExternalOrderShipmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyExternalOrderShipmentRoutes;
